// Vue 3 compatibility shim for vue-currency-filter
// Vue 3 removed filters, so we provide a global property and method instead

const defaultOptions = {
  symbol: "",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: true,
  avoidEmptyDecimals: undefined,
}

function formatCurrency(value, options = {}) {
  const opts = { ...defaultOptions, ...options }

  // vue-currency-filter formats an empty value as zero ("0,00"), not as ""
  if (value === null || value === undefined || value === "") {
    value = 0
  }

  const number = Number.parseFloat(value)
  if (isNaN(number)) {
    return value
  }

  // Handle fraction count
  const fixedNumber = number.toFixed(opts.fractionCount)
  let [intPart, fracPart] = fixedNumber.split(".")

  // Add thousands separator
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, opts.thousandsSeparator)

  // Build result
  let result = intPart
  if (opts.fractionCount > 0 && fracPart) {
    // Check if we should avoid empty decimals
    if (opts.avoidEmptyDecimals && /^0+$/.test(fracPart)) {
      // Skip decimals if all zeros and avoidEmptyDecimals is set
    } else {
      result += opts.fractionSeparator + fracPart
    }
  }

  // Add symbol
  if (opts.symbol) {
    const spacing = opts.symbolSpacing ? " " : ""
    if (opts.symbolPosition === "front") {
      result = opts.symbol + spacing + result
    } else {
      result = result + spacing + opts.symbol
    }
  }

  return result
}

export default {
  install(app, options = {}) {
    const mergedOptions = { ...defaultOptions, ...options }

    const currencyFn = (value, overrideOptions = {}) => {
      return formatCurrency(value, { ...mergedOptions, ...overrideOptions })
    }

    // Provide as global property for Options API
    app.config.globalProperties.$currency = currencyFn

    // Also provide the format function directly
    app.config.globalProperties.$formatCurrency = formatCurrency

    // Vue 2 compatibility: make $options.filters.currency() work
    // Vue 3 preserves custom options from mixins, so this makes
    // the Vue 2 pattern $options.filters.currency() available in all components
    app.mixin({
      filters: {
        currency: currencyFn,
      },
    })

    // Provide as injection for Composition API
    app.provide("currencyFilter", {
      format: (value, overrideOptions = {}) => formatCurrency(value, { ...mergedOptions, ...overrideOptions }),
      options: mergedOptions,
    })
  },
}

export { formatCurrency }
